import type { SearchFactFinderNgQuery } from '@/generated/graphql';

type SearchResult = NonNullable<SearchFactFinderNgQuery['searchFactFinderNg']>;

export type ItemRecord = NonNullable<NonNullable<SearchResult['masters']>['hits'][number]> &
  NonNullable<NonNullable<NonNullable<SearchResult['variants']>['hits']>[number]> & {
    masterValuesObject?: {
      masterProductData?: {
        bestPrice?: unknown;
      } | null;
    } | null;
  };

/**
 * The single product a search card renders, from whichever of the three shapes carries it:
 * a master with product data (FITE category pages), a variant enriched with catalog data
 * (FITE search), or a bare FactFinder variant (FIWE).
 */
export const resolveItemProduct = (record: ItemRecord, type: string): Record<string, any> => {
  const masterProductData = record.masterValuesObject?.masterProductData;
  const masterProduct = masterProductData?.catalogProductData;

  if (masterProduct) {
    return {
      ID: masterProduct.ProductId,
      Name: masterProduct.ProductName,
      ImageURL: masterProduct.imageUrl,
      Slug: masterProduct.Slug,
      bestPrice: masterProductData?.bestPrice,
      ProductPrice: masterProduct.ProductPrice,
      ProductPriceCurrency: masterProduct.ProductPriceCurrency,
      Attributes: masterProduct.Attributes,
    };
  }

  const variant = record?.variantValuesObject?.[0];
  if (!variant) {
    if (type !== 'family') {
      console.error('record missing variant', record, type);
    }
    return {};
  }

  // FITE has no families: the variant is the product, so its price and attributes
  // come from the catalog rather than from FactFinder.
  const variantProduct = (variant as any).catalogProductData;
  if (!variantProduct) {
    return variant;
  }

  return {
    ...variant,
    Name: variant.Name ?? variantProduct.ProductName,
    ImageURL: variant.ImageURL ?? variantProduct.imageUrl,
    Slug: variant.Slug ?? variantProduct.Slug,
    ProductPrice: variantProduct.ProductPrice,
    ProductPriceCurrency: variantProduct.ProductPriceCurrency,
    Attributes: variantProduct.Attributes,
  };
};
